import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import DrawPlayerItemV2 from './DrawPlayerItemV2';
import DrawTeamItemV2 from './DrawTeamItemV2';
import { setSelected, setSelectedTeams } from '../../actions/draw-edit-actions';
import { eventFormatTypeIds } from '../../utils/eventConstants';

const DrawRoundPlayersListV2 = (props) => {
    const {
        draw,
        parentDraw,
        available = [],
        selected,
        selectedTeams,
        utrType,
        playersDictByMemberId,
        teamsDict,
    } = props;

    const dispatch = useDispatch();

    function togglePlayerSelect(id) {
        const idx = selected.indexOf(id);
        if (idx > -1) {
            dispatch(setSelected([...selected.slice(0, idx), ...selected.slice(idx + 1)]));
        } else {
            dispatch(setSelected([...selected, id]));
        }
    }

    function toggleTeamSelect(id) {
        const idx = selectedTeams.indexOf(id);
        if (idx > -1) {
            const newSelectedTeams = [...selectedTeams.slice(0, idx), ...selectedTeams.slice(idx + 1)];
            dispatch(setSelectedTeams(newSelectedTeams));
        } else {
            const newSelectedTeams = [id, ...selectedTeams];
            dispatch(setSelectedTeams(newSelectedTeams));
        }
    }

    return (
        <>
            {available.map(player => {
                return draw.formatTypeId === eventFormatTypeIds.SINGLES
                    ? (
                        <DrawPlayerItemV2
                            key={`round-player-select-${player.memberId}`}
                            player={player}
                            isSelected={selected.includes(player.memberId)}
                            togglePlayerSelect={togglePlayerSelect}
                            utrType={utrType}
                            hidePopOverMenu={true}
                            drawId={draw.id}
                            parentDrawId={parentDraw.id}
                            data-testid={`draw-edit.player-${player.memberId}`}
                        />
                    ) : (
                        <DrawTeamItemV2
                            key={`round-team-select-${player.id}`}
                            teamId={player.id}
                            player1={player.members ? playersDictByMemberId[teamsDict[player.id].members[0]] : null}
                            player2={player.members ? playersDictByMemberId[teamsDict[player.id].members[1]] : null}
                            isSelected={selectedTeams.includes(player.id)}
                            utrType={utrType}
                            toggleTeamSelect={toggleTeamSelect}
                            hidePopOverMenu={true}
                            drawId={draw.id}
                            parentDrawId={parentDraw.id}
                            data-testid={`draw-edit.team-${player.id}`}
                        />
                    );
            })}
        </>
    );
};

DrawRoundPlayersListV2.propTypes = {
    draw: PropTypes.objectOf(any).isRequired,
    parentDraw: PropTypes.objectOf(any).isRequired,
};

DrawRoundPlayersListV2.defaultProps = {};

export default DrawRoundPlayersListV2;
